import BodyFooterLayout from './BodyFooterLayout';
import { BodyFooterLayoutProps, BodyFooterLayoutValueProps } from './types';

export type { BodyFooterLayoutProps, BodyFooterLayoutValueProps };
export default BodyFooterLayout;
